import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getSubmitSubmissionList } from "../../../features/slices/challanges";
import { useSelector } from "react-redux";
import moment from "moment";
import CommonPagination from "../../CommonPagination";

const WinnerList = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  useEffect(() => {
    dispatch(getSubmitSubmissionList({ challengeId: state }));
  }, []);
  const { submissionWinnerList } = useSelector((state) => {
    return state?.challenges;
  });
  console.log(submissionWinnerList,"submissionWinnerList")
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TableList">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Student Id</th>
                  <th>Student Name</th>
                  <th>Submitted On</th>
                  <th>Ranks &amp; Points</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {submissionWinnerList?.result?.paginationData?.map(
                  (res, i) => {
                    return (
                      <tr key={i + 1}>
                        <td>{i + 1}</td>
                        <td>{res?.studentData?.user_number}</td>
                        <td>{res?.studentData?.fullName}</td>
                        <td>{moment(res?.submitAt).format("DD/MM/YYYY")}</td>
                        <td>
                          <strong>{res?.studentRank || "N/A"} Rank,</strong>{" "}
                          {res?.studentPoints} Points
                        </td>
                        <td>
                          <div className="Actions">
                            <Link
                              to={"/challenges/submissionDetail"}
                              className="Eyes"
                              state={res}
                            >
                              <i className="fa-regular fa-eye" />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {submissionWinnerList?.result?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {submissionWinnerList?.result?.totalCount?.[0]?.count}{" "}
              results
            </p>
            <div className="PaginationRight">
              {submissionWinnerList?.result?.totalCount?.[0]?.count >
                0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    submissionWinnerList?.result?.totalCount?.[0]?.count ||
                    0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinnerList;
